



































































































































































































































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, watch } from '@vue/composition-api';
import * as Common from "../../commons/common"
import http from "../../plugins/http";
import moment from 'moment';
import AlertArea from "../../components/AlertArea.vue";
import DropArea from "../../components/DropArea.vue";
import { BModal } from 'bootstrap-vue';
import { SheetBase, SheetGroup, Student, Condition, Sheet } from "../../modules/teacher/ClassroomSheetEdit"

export class User {
  id: number
  login_id: string
  name: string
  curriculum_id: number[]
  role: string
  is_selected: boolean = false

  constructor(x: any){
    this.id = x.id;
    this.login_id = x.login_id;
    this.name = x.name;
    this.curriculum_id = !x.curriculum_id ? [] : x.curriculum_id.split(",").map((y: string) => Number(y));
    this.role = x.role;
  }
}

export interface Data {
  sheet_group_key: string
  tabNo: number
  sheetBase: SheetBase
  sheetGroups: SheetGroup[]
  errors: string[]
  isChangeCourse: boolean
  isNew: boolean
  selectedIdx: number
  curriculums: number[]
  courses: any[]
  copySheets: Sheet[]
  copyTargetSheet: Sheet
  condition: Condition
  totalCount: number
  users: User[]
  curriculum_users: User[]
  user_condition: any
  isAllCheckedUser: boolean
}

export default defineComponent({
  components: {
    "drop-area": DropArea,
    "alert-area": AlertArea,
  },
  setup(props, context){

    const modalCopySheetRef = ref<InstanceType<typeof BModal>>();

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      sheet_group_key: "",
      tabNo: 1,
      sheetBase: new SheetBase(),
      sheetGroups: new Array<SheetGroup>(),
      errors: new Array<string>(),
      isChangeCourse: false,
      isNew: false,
      selectedIdx: 0,
      curriculums: [],
      courses: [],
      copySheets: [],
      copyTargetSheet: null,
      condition: new Condition(),
      totalCount: 0,
      users: [],
      curriculum_users: [],
      user_condition: {
        name: "",
        role: "",
      },
      isAllCheckedUser: false
    });

    /******************************
     * 試験検索ボタン押下
     ******************************/

    const searchClick = () => {
      state.condition.page = 1;
      search();
    };

    /******************************
     * ページング
     ******************************/

    const changePage = (page: number) => {
      state.condition.page = page;
      search();
    };

    /******************************
     * 試験検索
     ******************************/

    const search = async () => {
      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/teacher/sheet_edit/search_sheet?${Common.BuildQuery(state.condition, 'search_sheet')}`).then(response => {
        state.copySheets = response.data.sheets.map((x: any) => new Sheet(x));
        state.copyTargetSheet = null;
        state.totalCount = response.data.sheets.length > 0 ? response.data.sheets[0].at_full_count : 0;
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * コピー対象試験選択
     ******************************/

    const setCopyTargetSheet = (sheet: any) => {
      state.copyTargetSheet = sheet;
      state.sheetBase.name = sheet.name;
      state.sheetBase.curriculum_id = sheet.curriculum_id;
      state.sheetBase.subject_name = sheet.subject_name;
      state.sheetBase.grade = sheet.grade;
      state.sheetBase.browse_lock = sheet.browse_lock;
      state.sheetBase.edit_lock = sheet.edit_lock;
      state.sheetBase.is_sort_answer_image_enable = sheet.is_sort_answer_image_enable;
      state.sheetBase.is_print_view_point = sheet.is_print_view_point;
      state.sheetBase.is_print_part1 = sheet.is_print_part1;
      state.sheetBase.is_disp_correct_question_image = sheet.is_disp_correct_question_image;

      modalCopySheetRef.value.hide();
    }

    /******************************
     * 検索条件クリア
     ******************************/

    const clearCondition = () => {
      const pageCache = state.condition.page;
      state.condition = new Condition();
      state.condition.page = pageCache;
    }

    /******************************
     * 実施日を画面表示文言にコンバート
     ******************************/

    const convertExecDate = (execDate: string) => {
      return execDate ? moment(execDate).format('M月D日') : "-";
    };

    const isEditable = computed(() => {
      return state.sheetBase.created_by == null || state.sheetBase.created_by == context.root.$store.state.currentUser.login_id || context.root.$store.state.currentUser.role != Common.RoleEnum.Teacher2;
    });

    // クラス情報マイナスアイコン押下
    const deleteSheetGroup = (idx: number) => {
      state.isChangeCourse = true;
      state.sheetGroups.splice(idx, 1);
    };

    // クラス情報プラスアイコン押下
    const addSheetGroup = () => {
      state.sheetGroups.push(new SheetGroup());
    };

    // コース変更時
    const changeCourse = (idx: number) => {
      state.sheetGroups[idx].course_name = getCourseNameByValue(state.sheetGroups[idx].course_id);
      state.isChangeCourse = true;
      if(state.sheetGroups[idx].course_id != state.sheetGroups[idx].course_id_cache){
        state.sheetGroups[idx].sheet_id = null;
      }else{
        state.sheetGroups[idx].sheet_id = state.sheetGroups[idx].sheet_id_cache;
      }
    };

    /******************************
     * 名簿エクセルテンプレートダウンロード
     ******************************/

    const downloadTemplate = async () => {
      
      await http.post(`/api/teacher/classroom_sheet_edit/download_excel`, {sheet_groups: state.sheetGroups}, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `meibo_crassroom.xlsx`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          const errorData = JSON.parse((new TextDecoder).decode(new Uint8Array(error.response.data)));
          state.errors = errorData.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    }


    const readMeibo = async (file: any) => {

      state.errors = []
      let fd = new FormData();
      fd.append('upload[file]', file);

      if(!window.confirm("名簿を読み込みます。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/classroom_sheet_edit/read_excel`, fd).then(response => {
        
        const excelStudents = response.data.students;

        for(let i = 0; i < excelStudents.length; i++){
          const excelStudent = excelStudents[i];
          const sheetGroup = state.sheetGroups.filter(x => x.course_name == excelStudent.course_name);
          if(sheetGroup.length == 1){
            const student = sheetGroup[0].students.filter(x => x.api_student_id == excelStudent.api_student_id);
            if(student.length == 0){
              state.errors.push(`${i + 1}行目の生徒のClassroom生徒IDが正しくありません。`);
            }
          }else{
            state.errors.push(`${i + 1}行目のコースが正しくありません。`);
          }
        }

        if(state.errors.length > 0){
          return;
        }

        for(let i = 0; i < excelStudents.length; i++){
          const excelStudent = excelStudents[i];
          const sheetGroup = state.sheetGroups.filter(x => x.course_name == excelStudent.course_name)[0];
          const student = sheetGroup.students.filter(x => x.api_student_id == excelStudent.api_student_id)[0];
          student.student_no = excelStudent.student_no;
          student.student_no_character = excelStudent.student_no_character;
        }

        alert("読み込みが完了しました。");
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 新規登録API
     ******************************/

    const createClick = async () => {
      if (!validate() || !window.confirm('試験を登録します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");

      const param: any = {
        sheet_base: state.sheetBase,
        sheet_groups: state.sheetGroups,
        copy_target_sheet_group_key: state.copyTargetSheet ? state.copyTargetSheet.sheet_group_key : null,
        scorable_login_ids: scorable_login_ids.value
      };

      await http.post(`/api/teacher/classroom_sheet_edit`, param).then(response => {
        alert("処理が完了しました。");
        context.root.$store.dispatch('goSheetList');
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 更新API
     ******************************/

    const updateClick = async () => {
      if (!validate() || !window.confirm('試験を更新します。よろしいですか？')) {
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.post(`/api/teacher/classroom_sheet_edit/update/${state.sheet_group_key}`, {sheet_base: state.sheetBase, sheet_groups: state.sheetGroups, scorable_login_ids: scorable_login_ids.value}).then(response => {
        alert("処理が完了しました。");
        context.root.$store.dispatch('goSheetList');
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    }

    /******************************
     * 削除API
     ******************************/

    const deleteClick = async () => {
      if(!window.confirm("試験を削除します。よろしいですか？")){
        return;
      }

      context.root.$store.dispatch("showOverlay");
      await http.delete(`/api/teacher/classroom_sheet_edit/${state.sheet_group_key}`).then(response => {
        alert("処理が完了しました。");
        context.root.$store.dispatch('goSheetList');
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * 登録前のデータチェック
     ******************************/

    const validate = () => {
      state.errors = new Array<string>();

      if (state.sheetBase.exec_date === "") {
        state.errors.push("実施日が入力されていません。");
      }
      if (state.sheetBase.name === "") {
        state.errors.push("試験名が入力されていません。");
      }
      if (state.sheetBase.curriculum_id === "") {
        state.errors.push("教科が選択されていません。");
      }
      if (state.sheetBase.grade === "") {
        state.errors.push("学年が選択されていません。");
      }
      for(let i = 0; i < state.sheetGroups.length; i++){
        if(state.sheetGroups[i].room_name === ""){
          state.errors.push(`クラス情報${i + 1}行目のクラス名が入力されていません。`);
        }else if(state.sheetGroups[i].course_id === ""){
          state.errors.push(`クラス情報${i + 1}行目のコースが選択されていません。`);
        }else if(state.sheetGroups[i].students.length == 0){
          state.errors.push(`クラス情報${i + 1}行目の受験者が存在しません。`);
        }

        for(let j = 0; j < state.sheetGroups[i].students.length; j++){
          if (!state.sheetGroups[i].students[j].student_no) {
            state.errors.push(`クラス情報${i + 1}行目：生徒情報${j + 1}行目の出席番号は必須です。`);
          }
        }

        // 出席番号重複チェック
        const student_nos = state.sheetGroups[i].students.filter(x => x.student_no).map(x => x.student_no.toString());
        if(isDuplicated(student_nos)){
          state.errors.push(`クラス情報${i + 1}行目の出席番号が重複しています。`);
        }
      }

      // コース重複チェック
      const course_ids = state.sheetGroups.filter(x => x.course_id).map(x => x.course_id);        
      if(isDuplicated(course_ids)){
        state.errors.push(`コースが重複しています。`);
      }

      return state.errors.length == 0;
    };

    /******************************
     * Classroom コース情報取得
     ******************************/
    const getClassroomCourses = async () => {

      const credentials = context.root.$store.state.gauthCredentials;
      await http.get(`/api/teacher/classroom_sheet_edit/course_list?credentials=${credentials}`).then(response => {
        if (response.data.error_type == "gapiAuthError") {
          context.root.$store.commit("setGauthRedirectPath", context.root.$route.path);
          window.location.href = response.data.auth_uri;
        } else {  
          state.courses = [{value: "", text: ""}];
          for(const course of response.data.courses){
            state.courses.push({value: course.id, text: course.name});
          }
          
          state.sheetGroups.forEach((sheetGroup: SheetGroup) => {
            if(!sheetGroup.course_id){
              return;
            }
            const courses = response.data.courses.filter((x: any) => x.id == sheetGroup.course_id);
            if(courses.length > 0){
              // コース名をsheetGroupにセット
              sheetGroup.course_name = courses[0].name;
            }else{
              // DBから取得したコースIDがAPIに存在しない場合、フラグを更新
              sheetGroup.is_course_exist = false;
            }
          });
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
    };

    /******************************
     * Classroom 生徒情報取得
     ******************************/
    const getClassroomStudents = async () => {

      context.root.$store.dispatch("showOverlay");

      const credentials = context.root.$store.state.gauthCredentials;
      let sheetGroups: any[] = [];
      state.sheetGroups.forEach((sheetGroup: SheetGroup) => {
        sheetGroups.push({
          'sheet_id': sheetGroup.sheet_id,
          'room_name': sheetGroup.room_name,
          'course_id': sheetGroup.course_id,
          'course_name': sheetGroup.course_name
        });
      });
  
      await http.post(`/api/teacher/classroom_sheet_edit/student_list`, {credentials: credentials, sheet_groups: state.sheetGroups}).then(response => {
        if (response.data.error_type == "gapiAuthError") {
          context.root.$store.commit("setGauthRedirectPath", context.root.$route.path);
          window.location.href = response.data.auth_uri;
        } else {
          const students = response.data.students;

          state.sheetGroups.forEach((sheetGroup: SheetGroup) => {
            sheetGroup.students = new Array<Student>();
            students.filter((x: any) => x.course_id == sheetGroup.course_id).forEach((x: any) => {
              let student = new Student();
              student.course_id = x.course_id;
              student.sheet_id = x.sheet_id;
              student.api_student_id = x.api_student_id;
              student.examinee_id = x.examinee_id;
              student.student_no = x.student_no;
              student.student_no_cache = x.student_no;
              student.student_no_character = x.student_no_character;
              student.student_name = x.student_name;
              student.is_uploaded = x.is_uploaded;
              sheetGroup.students.push(student);
            });
          });
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });

      context.root.$store.dispatch("hideOverlay");
    };

    /******************************
     * タブ切り替え
     ******************************/
    const changeTabNo = async (tabNo: number) => {

      if (tabNo == 2) {
        state.errors = new Array<string>();
        for(let i = 0; i < state.sheetGroups.length; i++){
          if(state.sheetGroups[i].course_id === ""){
            state.errors.push(`クラス情報${i + 1}行目のコースが選択されていません。`);
          }
        }
        // コース重複チェック        
        if(isDuplicated(state.sheetGroups.filter(x => x.course_id).map(x => x.course_id))){
          state.errors.push(`コースが重複しています。`);
        }
        if (state.errors.length > 0) {
          return;
        }

        // コースに変更があった場合、生徒情報を取得
        if (state.isChangeCourse) {
          state.isChangeCourse = false;
          await getClassroomStudents();
        }
        state.selectedIdx = 0;
      }
      state.tabNo = tabNo;
    }

    const getCourseNameByValue = (value: string) => {
      const courses = state.courses.filter(x => x.value == value);
      return courses.length > 0 ? courses[0].text : "";
    };

    /******************************
     * 配列に重複する値があるかどうか
     ******************************/

    const isDuplicated = (elements: string[]) => {
      const setElements = new Set(elements);
      return setElements.size !== elements.length;
    }

    /******************************
     * クラス一覧のレコード押下
     * 選択中のクラス情報切り替え
     ******************************/

    const sheetGroupRowClick = (idx: number) => {
      state.selectedIdx = idx;
    };

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay");

      state.isNew = context.root.$route.path.indexOf("new") != -1;
      if(state.isNew){
        // 新規登録の場合、空のクラス情報を1行作成
        state.sheetGroups.push(new SheetGroup());
        await http.get(`/api/teacher/sheet_edit/new`).then(response => {
          state.curriculums = response.data.curriculums;
          state.users = response.data.users.map((x: any) => new User(x));
        });
      }else{
        // 編集の場合、DBからクラス・人数情報取得
        state.sheet_group_key = context.root.$route.params.sheet_group_key;
        // APIで登録済み試験情報取得
        await http.get(`/api/teacher/classroom_sheet_edit?sheet_group_key=${state.sheet_group_key}`).then(response => {
          // 試験情報の１件目から表題情報取得
          state.sheetBase.grade = response.data.sheets[0].grade;
          state.sheetBase.grade_cache = response.data.sheets[0].grade;
          state.sheetBase.name = response.data.sheets[0].name;
          state.sheetBase.curriculum_id = response.data.sheets[0].curriculum_id;
          state.sheetBase.subject_name = response.data.sheets[0].subject_name;
          state.sheetBase.exec_date = moment(response.data.sheets[0].exec_date).format('YYYY-MM-DD');
          state.sheetBase.created_by = response.data.sheets[0].created_by;
          state.sheetBase.browse_lock = response.data.sheets[0].browse_lock;
          state.sheetBase.edit_lock = response.data.sheets[0].edit_lock;
          state.sheetBase.is_sort_answer_image_enable = response.data.sheets[0].is_sort_answer_image_enable;
          state.sheetBase.is_print_view_point = response.data.sheets[0].is_print_view_point;
          state.sheetBase.is_print_part1 = response.data.sheets[0].is_print_part1;
          state.sheetBase.api_type = response.data.sheets[0].api_type;
          state.sheetBase.is_disp_correct_question_image = response.data.sheets[0].is_disp_correct_question_image;

          // クラス情報取得
          response.data.sheets.forEach((sheet: any) => {
            let sheetGroup = new SheetGroup();
            sheetGroup.sheet_id = sheet.id;
            sheetGroup.sheet_id_cache = sheet.id;
            sheetGroup.room_name = sheet.room_name;
            sheetGroup.course_id = sheet.course_id;
            sheetGroup.course_id_cache = sheet.course_id;
            sheetGroup.course_name = sheet.course_name;
            sheetGroup.is_uploaded = sheet.sheet_activities_count > 0
            sheetGroup.students = new Array<Student>();
            state.sheetGroups.push(sheetGroup);
          });

          state.isChangeCourse = true;
          state.curriculums = response.data.curriculums;

          state.curriculums = response.data.curriculums;
          state.users = response.data.users.map((x: any) => new User(x));
          const scorable_login_ids = response.data.scorable_login_ids;

          context.root.$nextTick(() => {
            state.users.filter(x => scorable_login_ids.includes(x.login_id)).forEach(x => x.is_selected = true);
          });
        })
        .catch(error=>{
          // 後続処理不能のため一覧に戻る
          if(error.response.status == 422){
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。\n${error.response.data.errors[0]}`);
          }else{
            alert(`試験情報の取得処理に失敗しました。試験一覧に戻ります。`);
          }
          context.root.$store.dispatch('goSheetList');
        });
      }
      // Classroom コース情報
      await getClassroomCourses();

      context.root.$store.dispatch("hideOverlay");
    });

    /************************************************************
     * 教科ラジオボタン変更監視
     ************************************************************/

    watch(() => state.sheetBase.curriculum_id, async (newVal, oldVal) => {
      state.users.forEach(x => x.is_selected = false);
      state.curriculum_users = state.users.filter(x => x.role == "teacher1" || x.curriculum_id.includes(Number(newVal)));
    });

    /************************************************************
     * ユーザーモーダルの全件選択チェックボックず変更監視
     ************************************************************/
    
    watch(() => state.isAllCheckedUser, async (newVal, oldVal) => {
      state.curriculum_users.forEach(x => x.is_selected = newVal);
    });

    const searchUserClick = () => {
      let curriculum_users = state.users.filter(x => x.role == "teacher1" || x.curriculum_id.includes(Number(state.sheetBase.curriculum_id)));
      if(state.user_condition.name){
        curriculum_users = state.users.filter(x => x.name.includes(state.user_condition.name));
      }
      if(state.user_condition.role){
        curriculum_users = state.users.filter(x => x.role == state.user_condition.role);
      }
      state.curriculum_users = curriculum_users;
    }

    const clearUserCondition = () => {
      state.user_condition = {name: "", role: ""};
    }

    /************************************************************
     * 選択ユーザのログインID
     ************************************************************/

    const scorable_login_ids = computed((): string[] => {
      return state.curriculum_users.filter(x => x.is_selected).map(x => x.login_id);
    });

    return {
      ...toRefs(state),
      isEditable,
      deleteSheetGroup,
      addSheetGroup,
      changeCourse,
      createClick,
      updateClick,
      deleteClick,
      getClassroomCourses,
      getClassroomStudents,
      changeTabNo,
      getCourseNameByValue,
      sheetGroupRowClick,
      downloadTemplate,
      readMeibo,
      modalCopySheetRef,
      searchClick,
      clearCondition,
      convertExecDate,
      changePage,
      setCopyTargetSheet,
      searchUserClick,
      clearUserCondition,
    };
  }
})
